export default __webpack_public_path__ + "static/media/preloader-logo.7d3a3c90.svg";